import React, { useEffect, useState } from "react";
import "../style/dashboard.css";
import "../style/common.css";
import api from "../utils/api";
import { ButtonComponent } from "../component/Common";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { IoMdAdd } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const Dashboard = () => {
    const navigate = useNavigate();
    const [isInitialLoad, setIsInitialLoad] = useState(true);
    const [mortgages, setMortgages] = useState([]);
    const [isNoData, setIsNoData] = useState(false);

    useEffect(() => {
        setIsInitialLoad(false);
    }, []);

    useEffect(() => {
        if (!isInitialLoad) {
            fetchDashboardData();
        }
    }, [isInitialLoad]);

    const fetchDashboardData = async () => {
        try {
            const result = await api.get("/dashboard");
            if (result.status === 200 && Array.isArray(result.data) && result.data.length > 0) {
                const mortgagesData = result.data.map((item) => item.mortgage);
                setMortgages(mortgagesData);
                setIsNoData(false);
            } else {
                setIsNoData(true);
            }
        } catch (error) {
            setIsNoData(true);
        }
    };

    const handleButtonClick = () => {
        navigate(`/mortgage_form/initial-requirement`);
    };

    const openForm = (applicationId) => {
        // navigate(`/mortgage_form/0`);
        navigate(`/mortgage_form/0?applicationId=${applicationId}`);
    };

    const lockApplication = async (applicationId) => {
        const result = await api.get(`/lock-application/${applicationId}`);
        if (result.status == 200) {
            Swal.fire({
                icon: "success",
                title: "Application submitted",
                iconColor: '#008000',
                showConfirmButton: false,
                timer: 2000,
            });
            fetchDashboardData();
        } else if (result.status == 201) {
            Swal.fire({
                icon: "error",
                title: "Incomplete Form",
                text: result.data.message,
                // text: "Oops! It looks like you've missed filling out some sections of the form. Please go back and complete all the required fields before submitting.",
                iconColor: '#AB1717',
                showConfirmButton: true,
                confirmButtonColor: "#0E2F4F",
            });
        }
    }

    return (
        <>
            <div className="dashboard-container">
                <div className="table-container">
                    <div className="parent-div">
                        <div className="child1">
                            <h2>Welcome</h2>
                            {mortgages.length > 0 && (
                                <h2>{mortgages[0].phone}</h2>
                            )}
                        </div>
                        <div className="child2">
                            <ButtonComponent
                                tooltipId={"my-tooltip-2"}
                                icon={<IoMdAdd />}
                                name="Create New"
                                onClick={handleButtonClick}
                            />
                        </div>
                    </div>
                </div>

                {isNoData ? (
                    <div className="no-data-message">
                        <p>
                            You have not yet applied for any Loan. Click the
                            'Apply' button to get started with your application.
                        </p>
                    </div>
                ) : (
                    <div className="table-container">
                        {mortgages.map((mortgage, index) => (
                            <div className="row-container" key={index}>
                                <div className="row">
                                    <div className="heading-column">Application ID</div>
                                    <div className="data-column">{mortgage.applicationId}</div>
                                </div>
                                <div className="row">
                                    <div className="heading-column">Phone</div>
                                    <div className="data-column">{mortgage.mainUserPhone}</div>
                                </div>
                                <div className="row">
                                    <div className="heading-column">Loan Type</div>
                                    <div className="data-column">{mortgage.loanType}</div>
                                </div>
                                <div className="row">
                                    <div className="heading-column">Application Status</div>
                                    <div className="data-column">{mortgage.mainFormStatus}</div>
                                </div>
                                <div className="row">
                                    <div className="heading-column">Applicants</div>
                                    <div className="data-column">
                                        {mortgage.partner.length > 0
                                            ? mortgage.partner.join(", ")
                                            : "N/A"}
                                    </div>
                                </div>
                                {mortgage.feedback && mortgage.feedback.trim() !== "" && (
                                    <div className="row">
                                        <div className="heading-column">Feedback From Provider</div>
                                        <div className="data-column">{mortgage.feedback}</div>
                                    </div>
                                )}
                                <div className="row">
                                    <div className="heading-column">Action</div>
                                    <div className="data-column">
                                        {mortgage.mainFormStatus !== "Application Submitted" && mortgage.mainFormStatus !== "Accepted" ? (
                                            <div className="action-button">
                                                <ButtonComponent
                                                    name="View Details"
                                                    onClick={() => openForm(mortgage.id)}
                                                    disabled={mortgage.aplicationStatus === "Submit" || mortgage.aplicationStatus === "accept"}
                                                />
                                                {mortgage.usertype == "main user" && (
                                                    <ButtonComponent
                                                        name="Final Submission"
                                                        onClick={() => lockApplication(mortgage.id)}
                                                    />
                                                )}
                                            </div>
                                        ) : (
                                            <div className="status-div">
                                                <p>Your form is submitted successfully.</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                
                            </div>
                        ))}
                    </div>
                )}
            </div>
            <ReactTooltip
                id="my-tooltip-2"
                place="bottom"
                variant="info"
                content="Apply for new Loan"
            />
        </>
    );
};

export default Dashboard;